/**
 * Split a plan's limit rows for card display.
 *
 * A director shops by exactly two numbers — students and exams — so those lead the card in a
 * fixed order. Everything else (AI questions, PDF pages, video minutes) collapses behind a
 * "Bütün limitlər" expander, also in a fixed order so every tier's expanded table lines up.
 *
 * Rows are matched by `limitCode`; if the backend ever sends rows without codes, `primary`
 * comes back empty and `collapsible` false — callers then render the full list with no
 * expander, which is the pre-expander behaviour.
 */
const PRIMARY_ORDER = ["STUDENT_COUNT_LIMIT", "EXAM_COUNT_LIMIT"];
const REST_ORDER = ["AI_QUESTION_COUNT_LIMIT", "PDF_PAGE_LIMIT", "VIDEO_MINUTES_LIMIT"];

export function splitPlanLimits(limits) {
  const list = Array.isArray(limits) ? limits : [];
  const primary = PRIMARY_ORDER
    .map((code) => list.find((l) => l && l.limitCode === code))
    .filter(Boolean);
  const restRank = (l) => {
    const i = REST_ORDER.indexOf(l.limitCode);
    return i === -1 ? REST_ORDER.length : i;
  };
  const rest = list
    .filter((l) => l && !PRIMARY_ORDER.includes(l.limitCode))
    .sort((a, b) => restRank(a) - restRank(b));
  return { primary, rest, collapsible: primary.length > 0 && rest.length > 0 };
}
